// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const badgeWrapper = "TrendRank__badgeWrapper__LeSX3";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const hideRanking = "TrendRank__hideRanking__wXP+Q";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const slideButton = "TrendRank__slideButton__Koih4";
export const sliderWrapper = "TrendRank__sliderWrapper__Fjk-F";
export const title = "TrendRank__title__SxQVf";
export const trendRankWrapper = "TrendRank__trendRankWrapper__gHOhK";